import { FunctionField, NumberField } from "react-admin";

import { DEFAULT_CURRENCY, getCurrencyByCountry } from "../utils/priceUtils";

export const PriceField = ({ source, country, label, ...rest }) => (
  <FunctionField
    render={(record) => (
      <NumberField
        source={source}
        record={record}
        options={{
          style: "currency",
          currency:
            getCurrencyByCountry(country) ||
            getCurrencyByCountry(
              country?.split(".")?.reduce((o, i) => o?.[i], record)
            ) ||
            DEFAULT_CURRENCY,
        }}
        {...rest}
      />
    )}
    label={label}
  />
);
